import PlusIcon from '@assets/icons/plus.svg';
import React from 'react';
import { CircledIcon } from './circled-icon';
import {
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  ViewStyle,
} from 'react-native';

const HIT_SLOP = {
  bottom: 8,
  left: 8,
  right: 8,
  top: 8,
};

interface Props {
  onPress: () => void;
  style?: StyleProp<ViewStyle>;
}

export const PlusButtonAction: React.FC<Props> = ({ onPress, style }) => {
  return (
    <TouchableOpacity
      hitSlop={HIT_SLOP}
      onPress={onPress}
      style={[styles.addIngredientAction, style]}
      testID="plus-action-button"
    >
      <CircledIcon
        Icon={PlusIcon}
        iconHeight={20}
        iconWidth={20}
        style={styles.addIcon}
      />
    </TouchableOpacity>
  );
};

const ADD_INGREDIENT_BUTTON_SIZE = 40;

const styles = StyleSheet.create({
  addIcon: {
    height: ADD_INGREDIENT_BUTTON_SIZE,
    width: ADD_INGREDIENT_BUTTON_SIZE,
  },
  addIngredientAction: {
    alignItems: 'center',
    borderWidth: 0,
    justifyContent: 'center',
  },
});
